import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import UserBadgeImage from 'components/UserBadgeImage';
import Box from 'components/Box';
import Card from 'components/Card';
import Flex from 'components/Flex';
import VisuallyHidden from 'components/VisuallyHidden';
import { ActionMenu, IconsAndMenuBox, Image, Subtitle, getCardTitleId, getCardSubtitleId, getCardDescriptionId, getCardMenuId, CardTitle, CardLink } from '../shared';
import HoverDescription from './HoverDescription';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function VerticalCard(_ref) {
  var isFeedItem = _ref.isFeedItem,
    isDisabled = _ref.isDisabled,
    infoIcons = _ref.infoIcons,
    description = _ref.description,
    isFocusDisabled = _ref.isFocusDisabled,
    icon = _ref.icon,
    id = _ref.id,
    imageSource = _ref.imageSource,
    badge = _ref.badge,
    _ref$hasUserBadge = _ref.hasUserBadge,
    hasUserBadge = _ref$hasUserBadge === void 0 ? false : _ref$hasUserBadge,
    link = _ref.link,
    menuItems = _ref.menuItems,
    priorityPill = _ref.priorityPill,
    title = _ref.title,
    subtitle = _ref.subtitle,
    modalSlot = _ref.modalSlot;
  var titleId = getCardTitleId(id);
  var subtitleId = getCardSubtitleId(id);
  var descriptionId = getCardDescriptionId(id);
  var menuId = getCardMenuId(id);
  var cardLink = isDisabled ? undefined : link;
  return /*#__PURE__*/_jsxs(Card, {
    "aria-labelledby": titleId,
    as: !isFeedItem ? 'article' : undefined,
    variant: isDisabled ? 'default' : 'clickable',
    display: "flex",
    flexDirection: "column",
    height: "100%",
    children: [/*#__PURE__*/_jsx(Image, {
      link: cardLink,
      icon: icon,
      src: imageSource,
      children: description && /*#__PURE__*/_jsx(HoverDescription, {
        id: descriptionId,
        icon: icon,
        description: description
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      grow: true,
      column: true,
      alignItems: "stretch",
      position: "relative",
      py: "s",
      px: "m",
      mt: "-xxxs",
      children: [/*#__PURE__*/_jsxs(Box, {
        grow: true,
        children: [badge && !badge.isDeleted && /*#__PURE__*/_jsx(Box, {
          position: "relative",
          z: "raised",
          float: "right",
          mt: -44,
          mr: "-xs",
          ml: "xxxs",
          children: /*#__PURE__*/_jsx(UserBadgeImage, {
            badge: badge,
            hasUserBadge: hasUserBadge,
            size: 60
          })
        }), priorityPill && /*#__PURE__*/_jsx(Box, {
          ml: "-xxs",
          mb: "xxs",
          children: priorityPill
        }), /*#__PURE__*/_jsx(CardTitle, {
          id: titleId,
          mb: "xxs",
          children: /*#__PURE__*/_jsx(CardLink, {
            link: cardLink,
            maxLength: 85,
            isFocusDisabled: isFocusDisabled,
            children: title
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          id: subtitleId,
          children: subtitle
        }), description && /*#__PURE__*/_jsx(VisuallyHidden, {
          as: "p",
          "aria-labelledby": descriptionId
        })]
      }), /*#__PURE__*/_jsx(IconsAndMenuBox, {
        pl: "xs",
        mt: "xxs",
        mr: "-xs",
        children: /*#__PURE__*/_jsxs(Flex, {
          align: "top",
          children: [infoIcons, menuItems && /*#__PURE__*/_jsx(ActionMenu, {
            items: menuItems,
            id: menuId,
            titleId: titleId
          })]
        })
      })]
    }), modalSlot]
  });
}
export default VerticalCard;